/**
 * Ponte entre o interceptor do axios (fora do React) e o UpgradeProvider (React).
 * O provider registra o handler no mount; o interceptor 402 dispara o handler com
 * o payload estruturado do backend ({ error, limitKey, featureKey, suggestedPlanSlug, message }).
 */
let handler = null;

export function setUpgradeHandler(fn) {
  handler = fn;
}

export function triggerUpgrade(context) {
  if (typeof handler === 'function') {
    handler(context);
    return true;
  }
  return false;
}
